import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import teamReducer from './slices/teamSlice';
import leagueReducer from './slices/leagueSlice';
import gameReducer from './slices/gameSlice';
import uiReducer from './slices/uiSlice';
import standingsReducer from './slices/standingsSlice';
import enrollmentReducer from './slices/enrollmentSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    team: teamReducer,
    league: leagueReducer,
    game: gameReducer,
    ui: uiReducer,
    standings: standingsReducer,
    enrollment: enrollmentReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore certain action types that may contain non-serializable values
        ignoredActions: ['auth/loginSuccess', 'auth/refreshTokenSuccess'],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
